import instance from "../../axios/axios-user";
import PostGIFProps from "../../redux/slices/postGIF/postGIF";
import { API_PATHS } from "../api_paths";

const getPostGIF = (gif_id: string) =>
  instance(API_PATHS.postGIF.getPostGIF + gif_id);

const uploadGIFForAPost = ({
  post_id,
  gif_id,
  name,
  type,
  url,
}: PostGIFProps.UploadGIFForAPostPayload) =>
  instance(API_PATHS.posts.post + post_id + "/gifs", {
    method: "POST",
    data: {
      gif_id,
      name,
      type,
      url,
    },
  });

const deleteGIFForAPost = ({
  post_id,
  gif_id,
}: PostGIFProps.DeleteGIFForAPostPayload) =>
  instance(API_PATHS.posts.post + post_id + "/gifs/" + gif_id, {
    method: "DELETE",
  });

export const POSTGIF = { getPostGIF, uploadGIFForAPost, deleteGIFForAPost };
